import { useMutation } from "react-query";

import { Endpoints } from "../../enums/Endpoints";
import { QueryParams } from "../../enums/QueryParams";
import { IImageUploadParams } from "../../types/Image.types";
import { smartposUrl } from "../ApiClient";

const { UPLOAD_IMAGE } = Endpoints;
const { UPLOAD_IMAGE_KEY } = QueryParams;

 const UploadImageHeaders = {
  accept: "application/json",
  "Accept-Language": "en-US,en;q=0.8",
  "Content-Type": "multipart/form-data;",
};


export const uploadImage = async (uploadImagesParams: IImageUploadParams) => {
  const shopId: string = localStorage.getItem("shopId");
  const data = new FormData();
  const cleanedBase64 = uploadImagesParams.data?.replace(
    /^data:image\/(png|jpeg|jpg);base64,/,
    ""
  );
  const blobImg = new Blob([cleanedBase64]);
  data.append("file", blobImg, uploadImagesParams.filename);

  const response = (
    await smartposUrl.post(`${UPLOAD_IMAGE}${shopId}`, data, {
      headers: UploadImageHeaders,
      timeout: 30 * 1000,
    })
  ).data;
  return response;
};

export const useUploadProductImageMutation = () => {
  const uploadImageMutation = useMutation({
    mutationKey: [UPLOAD_IMAGE_KEY],
    mutationFn: uploadImage,
  });
  return uploadImageMutation;
};

export default useUploadProductImageMutation;
